import React from "react";

const ProductLabel = ({ data, onSale }) => {
	const showDefault = !data.highPriority && onSale;
	const text = showDefault ? "On sale" : data.text;
	if (!text) return null;

	const bgColor = !showDefault && data.background ? { backgroundColor: data.background } : {};
	const textColor = !showDefault && data.textColor ? { color: data.textColor } : {};

	return (
		<div className="absolute top-0 p-4 md:group-hover/card:opacity-0 transition-all duration-300 label-v2-t">
			<div style={bgColor} className="py-1 px-2 md:py-1.5 md:px-4 bg-beige">
				<p style={textColor} className="font-semibold uppercase text-xs">
					{text}
				</p>
			</div>
		</div>
	);
};

export default ProductLabel;